import React from 'react';
import '../../styles/caricamento.css';

/**
 * L'attesa, uguale dappertutto.
 *
 * Due pezzi insieme, perche' la sensazione di velocita' non viene
 * dall'animazione veloce ma dal non far vedere il vuoto e dal non far
 * saltare la pagina:
 *
 *   - la BARRA in cima alla finestra dice che si sta lavorando senza
 *     rubare spazio: il contenuto resta dov'e';
 *   - lo SCHELETRO riempie l'area con la forma delle righe in arrivo, e
 *     quando i dati arrivano le righe vere prendono il loro posto senza
 *     spostare niente.
 *
 * forma:
 *   'partite' — scheletro di righe partita (nome, orario, tre quote)
 *   'righe'   — scheletro di righe semplici, per tabelle ed elenchi
 *   'barra'   — solo la barra, quando il contenuto c'e' gia' e si aggiorna
 *   'anello'  — anello che gira, quando non c'e' spazio per altro
 *
 * righe:   quante ne disegna lo scheletro (predefinito 5)
 * testo:   cosa si sta aspettando (letto anche da chi usa lo schermo a voce)
 * piena:   occupa l'area e centra, invece di stare in linea
 * piccolo: anello minuto in linea, senza barra — per un campo, non una pagina
 */
class Caricamento extends React.Component {
  render() {
    const {forma, righe, testo, piena, piccolo} = this.props;
    const quante = typeof righe === 'number' && righe > 0 ? righe : 5;
    const elenco = Array.from({length: quante}, (_, i) => i);
    const etichetta = testo || 'Caricamento in corso';

    /* Un'attesa piccola dentro un campo non merita la barra di tutta la
       finestra: sarebbe un allarme per una riga. */
    if (piccolo) {
      return (
        <span className={'lvc-attesa in-linea'} role={'status'} aria-live={'polite'}>
          <span className={'lvc-anello piccolo'}/>
          {testo && <span className={'lvc-attesa-testo'}>{testo}</span>}
        </span>
      );
    }

    const barra = <span className={'lvc-barra-attesa'} aria-hidden={'true'}/>;

    if (forma === 'partite') {
      return (
        <React.Fragment>
          {barra}
          <div className={'lvc-scheletro-elenco'}
            role={'status'} aria-live={'polite'} aria-label={etichetta}>
            {elenco.map((i) => (
              <div className={'lvc-scheletro-partita'} key={i}>
                <span className={'lvc-scheletro titolo'}/>
                <span className={'lvc-scheletro sottotitolo'}/>
                <div className={'caselle'}>
                  <span className={'lvc-scheletro'}/>
                  <span className={'lvc-scheletro'}/>
                  <span className={'lvc-scheletro'}/>
                </div>
              </div>
            ))}
          </div>
        </React.Fragment>
      );
    }

    if (forma === 'righe') {
      return (
        <React.Fragment>
          {barra}
          <div className={'lvc-scheletro-elenco'}
            role={'status'} aria-live={'polite'} aria-label={etichetta}>
            {elenco.map((i) => (
              <span
                className={'lvc-scheletro lvc-scheletro-riga' +
                  (i === quante - 1 ? ' corta' : '')}
                key={i}
              />
            ))}
          </div>
        </React.Fragment>
      );
    }

    if (forma === 'barra') {
      return (
        <React.Fragment>
          {barra}
          <span className={'lvc-solo-voce'} role={'status'} aria-live={'polite'}>
            {etichetta}
          </span>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        {barra}
        <div className={'lvc-attesa' + (piena ? ' piena' : '')}
          role={'status'} aria-live={'polite'}>
          <span className={'lvc-anello'}/>
          {testo && <p className={'lvc-attesa-testo'}>{testo}</p>}
        </div>
      </React.Fragment>
    );
  }
}

export default Caricamento;
